var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#014935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86627 8.80365C9.57337 8.51076 9.0985 8.51076 8.80561 8.80365C8.51271 9.09655 8.51271 9.57142 8.80561 9.86431L9.86627 8.80365ZM14.1389 15.1976C14.4318 15.4905 14.9067 15.4905 15.1996 15.1976C15.4925 14.9048 15.4925 14.4299 15.1996 14.137L14.1389 15.1976ZM15.1996 9.86431C15.4925 9.57142 15.4925 9.09655 15.1996 8.80365C14.9067 8.51076 14.4318 8.51076 14.1389 8.80365L15.1996 9.86431ZM8.80561 14.137C8.51271 14.4299 8.51271 14.9048 8.80561 15.1976C9.0985 15.4905 9.57337 15.4905 9.86627 15.1976L8.80561 14.137ZM8.80561 9.86431L14.1389 15.1976L15.1996 14.137L9.86627 8.80365L8.80561 9.86431ZM14.1389 8.80365L8.80561 14.137L9.86627 15.1976L15.1996 9.86431L14.1389 8.80365Z",
    fill: "#90D3BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRemoveIcon);
export default __webpack_public_path__ + "static/media/profile-remove-icon.b37d09e6dcfeb583a37aafcadcd0d26f.svg";
export { ForwardRef as ReactComponent };